// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__12jjz","rootCenter":"LoadMoreObserver_rootCenter__1H3sH","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2WEFs"};